export default "__VITE_ASSET__DDcyq1co__"